// extracted by mini-css-extract-plugin
export default {"bodyClass":"styles_bodyClass__sk1pZ","space":"styles_space__4PdT-","sticky":"styles_sticky__VKVt+"};